import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';

import Button from 'shopper/components/Button';

import FormHeading from 'components/SuggestNewItem/FormHeading';
import TabNav from 'components/SuggestNewItem/TabNav';

import useKeyDown from 'hooks/useKeyDown';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';
import { isUrlValid } from 'lib/string';

const isUrlWithPath = (url) => /^http(s?):\/\/[a-z0-9-_.]+\.[a-z]+/gi.test(url);

const OfferLinkForm = ({ gaEventCategory, offerUrl = '', onNextClick }) => {
  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      offerUrl,
    },
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const isNextButtonDisabled =
    !isUrlValid(watch('offerUrl')) || !isUrlWithPath(watch('offerUrl'));

  const onNextClickHandler = () => {
    sendEvent({
      action: 'link_offer_submit',
      category: gaEventCategory,
    });

    return handleSubmit(onNextClick)();
  };

  useKeyDown(['Enter', 'NumpadEnter'], onNextClickHandler, {
    enabled: !isNextButtonDisabled,
  });

  return (
    <>
      <TabNav gaEventCategory={gaEventCategory} />
      <div className="flex flex-col px-2 pb-6 lg:px-4">
        <FormHeading
          className="my-4 md:my-6"
          description={placeholder('descriptions.suggestOffer')}
          inputProps={{
            control,
            defaultMessage: placeholder(
              'inputs.errors.others.offerUrlDisclaimer'
            ),
            label: placeholder('inputs.labels.offerUrl'),
            name: 'offerUrl',
            placeholder: placeholder('inputs.placeholders.offerUrl'),
            onFocus: () =>
              sendEvent({ action: 'url_focus', category: gaEventCategory }),
            rules: {
              validate: {
                validateUrl: (value) =>
                  (isUrlValid(value) && isUrlWithPath(value)) ||
                  placeholder('inputs.errors.invalid.offerUrl'),
              },
            },
          }}
          title={placeholder('titles.suggestOffer')}
        />
        <Button
          className="self-end lg:w-fit"
          disabled={isNextButtonDisabled}
          full
          onClick={onNextClickHandler}
        >
          {placeholder('actions.next')}
        </Button>
      </div>
    </>
  );
};

OfferLinkForm.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  offerUrl: PropTypes.string,
  onNextClick: PropTypes.func.isRequired,
};

export default OfferLinkForm;
